export class Inventario {

public CODIGOARTICULO: string;
public DISPONIBLE: number;
public APTO: number;
public NO_APTO: number;
public RESERVADO: number;

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/inventario.ts